import infrasController from "@/services/infrasService";
import deviceTypeController from "@/services/deviceTypeService";
import siteController from "@/services/siteService";
import divisionController from "@/services/divisionService";
import parameterController from "@/services/parameterService";
import Swal from "sweetalert2";

export default {
  name: "InfrasView",

  data() {
    return {
      loading: false,
      infras: [],
      total: 0,
      page: 1,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],

      deviceTypeList: [],
      siteList: [],
      divisionList: [],
      deviceCategoryList: [],

      filters: {
        search: "",
        device_type_id: null,
        device_category: null,
        mst_site_id: null,
        mst_division_id: null,
        status: "",
      },
    };
  },

  computed: {
    totalPages() {
      // guard supaya tidak NaN/Infinity
      if (!this.total || !this.perPage) return 1;
      return Math.ceil(this.total / this.perPage);
    },

    visiblePages() {
      const total = this.totalPages;
      const current = this.page;
      const delta = 2;
      const range = [];

      for (
        let i = Math.max(2, current - delta);
        i <= Math.min(total - 1, current + delta);
        i++
      ) {
        range.push(i);
      }

      if (current - delta > 2) range.unshift("...");
      if (current + delta < total - 1) range.push("...");

      range.unshift(1);
      if (total > 1) range.push(total);

      return range;
    },
  },

  methods: {
    // Satu status per header (gaya sama dengan tabel PKS):
    //  EXPIRED  -> ada asset number yang expired
    //  ACTIVE   -> ada asset number yang aktif
    //  INACTIVE -> semua asset number inactive
    // Rincian jumlah ditampilkan sebagai tooltip.
    headerStatus(item) {
      const active = Number(item.count_active) || 0;
      const inactive = Number(item.count_inactive) || 0;
      const expired = Number(item.count_expired) || 0;
      if (active + inactive + expired === 0) return null;

      let label = "ACTIVE";
      let cls = "badge-success";
      if (expired > 0) {
        label = "EXPIRED";
        cls = "badge-danger";
      } else if (active === 0) {
        label = "INACTIVE";
        cls = "badge-secondary";
      }

      const title = [
        active ? `Active: ${active}` : null,
        inactive ? `Inactive: ${inactive}` : null,
        expired ? `Expired: ${expired}` : null,
      ]
        .filter(Boolean)
        .join(" · ");

      return { label, cls, title };
    },

    formatDate(date) {
      if (!date) return "-";
      return new Intl.DateTimeFormat("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(new Date(date));
    },

    goToAdd() {
      this.$router.push("/asset/infrastructure-it/add");
    },
    goToDetail(id) {
      this.$router.push(`/asset/infrastructure-it/detail/${id}`);
    },
    goToEdit(id) {
      this.$router.push(`/asset/infrastructure-it/edit/${id}`);
    },

    async loadMasterData() {
      try {
        const [deviceType, site, division, category] = await Promise.all([
          deviceTypeController.getAll({ limit: 0 }),
          siteController.getAll({ limit: 0 }),
          divisionController.getAll({ limit: 0 }),
          parameterController.getAll({ param_id: 7 }),
        ]);
        this.deviceTypeList = deviceType.data || [];
        this.siteList = site.data || [];
        this.divisionList = division.data || [];
        this.deviceCategoryList = category.data || [];
      } catch (error) {
        console.error(error);
      }
    },

    applyFilters() {
      this.page = 1;
      this.getData();
    },

    changePerPage() {
      this.page = 1;
      this.getData();
    },

    async getData() {
      try {
        this.loading = true;
        const res = await infrasController.getAll({
          page: this.page,
          limit: this.perPage,
          search: this.filters.search || null,
          device_type_id: this.filters.device_type_id || null,
          device_category: this.filters.device_category || null,
          mst_site_id: this.filters.mst_site_id || null,
          mst_division_id: this.filters.mst_division_id || null,
          status: this.filters.status || null,
          sortBy: "infrastructure_id",
          sortDesc: "true",
        });

        this.infras = Array.isArray(res.data) ? res.data : [];
        this.total = Number(res.total) || 0;
        if (this.page > this.totalPages) {
          this.page = this.totalPages;
          await this.getData();
        }
      } catch (error) {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: "Gagal memuat data infrastruktur",
        });
      } finally {
        this.loading = false;
      }
    },

    changePage(p) {
      if (p < 1 || p > this.totalPages) return;
      this.page = p;
      this.getData();
    },
  },

  async mounted() {
    await this.loadMasterData();
    this.getData();
  },
};
